import styled from 'styled-components';

export const ErrorBoundaryContainer = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  height: auto;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  overflow-x: hidden;
  overflow-y: auto;
  overflow-wrap: anywhere;
  text-align: center;
  background-color: #1e1e1e;
  color: rgb(237, 236, 236, 0.85);

  & > * {
    max-width: 100%;
  }

  p {
    white-space: pre-wrap;
    word-break: break-word;
  }
`;

export const ErrorBoundaryLink = styled.a`
  text-decoration: none;
  font-weight: 600;
  color: rgb(237, 236, 236, 0.85);
  padding: 8px;
  border: 1px solid rgb(237, 236, 236, 0.85);
  border-radius: 4px;
  margin-bottom: 16px;
`;

export const ErrorBoundaryButton = styled.button`
  border: none;
  background-color: rgb(237, 236, 236, 0.85);
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
`;

export const ErrorBoundaryError = styled.h4`
  color: tomato;
  overflow-wrap: anywhere;
`;
